import { Redirect,Route } from "react-router-dom";
import AuthContext from "context/AuthContext";
import React, { useContext } from "react";
import PropTypes from 'prop-types';

const ProtectedRoute = ( { component: Component, ...rest }) => {

  const authContext = useContext(AuthContext);
  //const [rolesArray,setRolesArray] = useState([]);


  //setRolesArray(allowedRoles);
  return (
    <Route
      {...rest}
      render={props =>
        (authContext.user.token != null) ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/auth/login-page",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );




/*

  if (authContext.token == null) {
    console.log("Auth Token is null");
    <Redirect to={{  pathname: "/auth/login-page", state: { from: props.location }
    return <Redirect to="/auth/login-page" replace />;
  }
 /* else if (!authContext.roles?.find(role => rolesArray.includes(role))) {
    console.log("Role was not fould in Roles");
    return <Redirect to="/unAuthorized" replace />;
  }
  return children;
  */
};

ProtectedRoute.propTypes = {
  component: PropTypes.any,
  location:PropTypes.any,
}
export default ProtectedRoute;
